import React,{ useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { NavBarData, FooterData } from './NavData'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ProfileMainIcon from "../../assets/images/userImg.svg";

export default ({ component: Component, ...rest }) => {
	const auth = useSelector((state) => state.auth.isSignedIn);
    const userInfo = useSelector((state) => state.auth.adminData);
	
		if(auth){
		return (
		<Route
			{...rest}
			render={(props) => 
					 (
						<>
							<ToastContainer position="top-center" autoClose={2000}/>

							<Header profileImage={userInfo.image ? userInfo.image : ProfileMainIcon} navBarData={NavBarData} />
								<section id="body">
									<Component {...props} />
								</section>
								
							<Footer footerData={FooterData}/>
							
						</>
					)
			}
		/>
	)}
	else{
		return (
			<Redirect
				to={{
					pathname: '/login',
				}}
			/>
		);
	}
};
